module.exports = __webpack_public_path__ + "assets/img/3.15015309.webp";